import React from "react";

const NotFound = () => {
  return (
    <div className="container">
      <h1 className="text-center mt-5">Woah there!</h1>
      <h2 className="text-center">You must have taken a wrong turn.</h2>
      <h5 className="text-center text-muted">404 - Page Not Found</h5>
    </div>
  );
};

export default NotFound;
